module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b19c4b48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/charts/column.vue
// module id = 1436
// module chunks = 1